module.exports = __webpack_public_path__ + "img/SKWINKELNetActieInschrijven5FA7C4.3bdc32e2.png";